import { Style } from 'ol/style'

import { genericStyles } from '../../genericStyles'

const deviceLabelStylesCache: Map<string, Style> = new Map()

export const getDeviceFeatureLabelStyle = (
  marker: uui.domain.ui.map.markers.Device,
  mode: uui.domain.ui.map.markers.MapStyles['device']['mode'],
) => {
  if (mode !== 'label') return genericStyles.hidden

  const cacheId = `${mode}_${marker.label}`

  if (deviceLabelStylesCache.has(cacheId)) {
    const cachedStyle = deviceLabelStylesCache.get(cacheId)

    if (cachedStyle) return cachedStyle
  }

  const style = genericStyles.label.clone()
  const textInstance = style.getText()

  textInstance.setText(marker.label)
  textInstance.setOffsetY(35)

  deviceLabelStylesCache.set(cacheId, style)

  return style
}
